import { HandlersCollection } from '@tblabs/truffle';
import { IServer } from './IServer';
import { Translations } from '../Translations/Translations';
import { Status } from './Status/Status';
import { StatusEvent } from './Status/StatusEvent';
import { IWatcher } from './IWatcher';


export class Watcher implements IWatcher
{
    public OnKick = new HandlersCollection<(reason: string) => void>();
    public OnMessage = new HandlersCollection<(message: string) => void>();

    constructor(private _server: IServer, private _lang: Translations, private _status: Status)
    { }

    public Init(): void
    {
        this._server.Socket
            .on('watcher:unauthorized', () =>
            {
                this._status.Set(StatusEvent.Unauthorized);

                this.OnKick.Call(this._lang.Unauthorized);
            })
            .on('watcher:already-logged-in', () =>
            {
                this._status.Set(StatusEvent.AlreadyLoggedIn);

                this.OnKick.Call(this._lang.AlreadyLoggedIn);
            })
            .on('watcher:invalid', () =>
            {
                this._status.Set(StatusEvent.Unauthorized);

                this.OnKick.Call(this._lang.InvalidPassword);
            })
            .on('watcher:limit', () =>
            {
                this._status.Set(StatusEvent.Unauthorized);

                this.OnKick.Call(this._lang.WatchersLimitExceeded);
            })
            .on('watcher:kick', () =>
            {
                this._status.Set(StatusEvent.Unauthorized);

                this.OnKick.Call(this._lang.ConnectionInterruptedByAdmin);
            })
            .on('watcher:message', (message: string) =>
            {
                this.OnMessage.Call(message);
            })
    }
}
